import React from "react";
import { Table } from "react-bootstrap";

const CustomerCredits = ({ credits = [], remainingAmount = 0 }) => {
    if (!credits.length) return null;

    return (
        <div className="mt-4">
            <h5 className="mb-3">Customer Credits</h5>
            <Table striped bordered hover responsive className="align-middle">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Remarks</th>
                        <th>Created At</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {credits.map((credit, index) => (
                        <tr key={credit.id}>
                            <td>{index + 1}</td>
                            <td>{credit.type}</td>
                            <td>{credit.remarks}</td>
                            <td>{new Date(credit.created_at).toLocaleString()}</td>
                            <td>{Number(credit.amount).toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="text-end fw-bold">
                            Customer Credits Left
                        </td>
                        <td className="fw-bold">
                            {Number(remainingAmount ?? 0).toFixed(2)}
                        </td>
                    </tr>
                </tfoot>
            </Table>
        </div>
    );
};

export default CustomerCredits;
